module.exports = __webpack_public_path__ + "media/images/new-ui-images/form-5c6dfc711619b4827ee7e03daed9af15.svg";